import EditProductChange from './EditProductChange';

export default EditProductChange;
